





































































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import * as Ssn from "@/shared/ssn";
import { Beneficiary, BeneficiaryType, BeneficiaryRelationshipType, BeneficiaryStatus, BeneficiaryUpdateRequest, BeneficiaryShare } from "@/shared/types";
import _ from "lodash";
import EditBeneficiary from "@/employee/components/settings/profile/EditBeneficiary.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useThemeStore } from "@/shared/store/theme";

const emptyBeneficiary: Beneficiary = {
  id: 0,
  firstName: "",
  middleInitial: "",
  lastName: "",
  dateOfBirth: "",
  ssn: "",
  address1: "",
  address2: "",
  city: "",
  stateCode: "",
  zip: "",
  share: 0,
  type: BeneficiaryType.None,
  relationshipType: BeneficiaryRelationshipType.None,
  status: BeneficiaryStatus.Active,
  estateName: ""
};

@Component({
  components: { EditBeneficiary }
})
export default class BeneficiaryTable extends Vue {
  @Prop ()
  beneficiaries;

  @Prop ({ required: false, default: true })
  isActive: boolean;

  @Prop ()
  isEditable: boolean;

  custodianSettingsStore = useCustodianSettingsStore();
  bankAccountStore = useBankAccountStore();
  themeStore = useThemeStore();
  formatDateString = formatMMddyyyyDateString;

  editBeneficiaryParameters = {
    show: { value: false },
    beneficiary: { ...emptyBeneficiary },
    currentBeneficiaries: [],
    onSave: this.onSaveBeneficiary,
    toggleClose: this.closeEditBeneficiaryForm,
    isNew: false,
    hasStatusChanged: false
  };
  showDeactivateConfirmationModal = false;
  showActivateConfirmationModal = false;
  isDeactivating = false;
  isActivating = false;

  get canEdit () {
    return this.isEditable;
  }

  get allBeneficiaries () {
    const all = Object.keys(this.bankAccountStore.beneficiaries).map(key => this.bankAccountStore.beneficiaries[key]);
    return all.filter(x => x.status === BeneficiaryStatus.Active);
  }

  onSaveBeneficiary () {
    return this.bankAccountStore.updateBeneficiary(this.buildBeneficiaryUpdateRequest())
      .then(() => {
        this.editBeneficiaryParameters.show.value = false;
      })
      .catch(() => {/*noop*/ });
  }

  buildBeneficiaryUpdateRequest (): BeneficiaryUpdateRequest {
    const ob: BeneficiaryShare[] = [];
    this.editBeneficiaryParameters.currentBeneficiaries.forEach(element => {
      const beneficiaryShare = {
        beneficiaryId: element.id,
        share: element.share
      };
      ob.push(beneficiaryShare);
    });

    return { ...this.editBeneficiaryParameters.beneficiary, beneficiaryShares: ob };
  }

  closeEditBeneficiaryForm () {
    this.editBeneficiaryParameters.show.value = false;
  }

  showEditBeneficiaryForm (beneficiary: Beneficiary) {
    this.editBeneficiaryParameters.beneficiary = _.cloneDeep(beneficiary);
    this.editBeneficiaryParameters.currentBeneficiaries = _.cloneDeep(this.allBeneficiaries.filter(b => b.id !== beneficiary.id));
    this.editBeneficiaryParameters.show.value = true;
    this.editBeneficiaryParameters.hasStatusChanged = false;
  }

  onDeactivateBeneficiary (beneficiary: Beneficiary) {
    const b = _.cloneDeep(beneficiary);
    b.status = BeneficiaryStatus.Inactive;
    b.share = 0;
    this.editBeneficiaryParameters.beneficiary = b;
    this.editBeneficiaryParameters.currentBeneficiaries = _.cloneDeep(this.allBeneficiaries.filter(b => b.id !== beneficiary.id));
    this.editBeneficiaryParameters.show.value = true;
    this.editBeneficiaryParameters.hasStatusChanged = true;
  }

  onActivateBeneficiary (beneficiary: Beneficiary) {
    const b = _.cloneDeep(beneficiary);
    b.status = BeneficiaryStatus.Active;
    this.editBeneficiaryParameters.beneficiary = b;
    this.editBeneficiaryParameters.currentBeneficiaries = _.cloneDeep(this.allBeneficiaries.filter(b => b.id !== beneficiary.id));
    this.editBeneficiaryParameters.show.value = true;
    this.editBeneficiaryParameters.hasStatusChanged = true;
  }

  closeActivateConfirmationModal () {
    this.showActivateConfirmationModal = false;
  }

  collapseId (id) {
    return `collapse-${id}`;
  }

  toggleDetails (id) {
    this.$root.$emit("bv::toggle::collapse", id);
    this.toggleCollapsedClass(id);
  }

  toggleCollapsedClass (id) {
    const elem = document.getElementById(id);
    if (elem.classList.contains("collapsed")) {
      elem.classList.remove("collapsed");
    } else {
      elem.classList.add("collapsed");
    }
  }

  middleInitial (beneficiary: Beneficiary) {
    if (beneficiary.middleInitial) {
      return beneficiary.middleInitial;
    }
    return "";
  }

  fullName (beneficiary: Beneficiary): string {
    if (this.isEstateBeneficiary(beneficiary)) {
      return beneficiary.estateName;
    }
    return `${beneficiary.firstName} ${this.middleInitial(beneficiary)} ${beneficiary.lastName}`;
  }

  dateOfBirth (beneficiary: Beneficiary): string {
    return this.formatDateString(beneficiary.dateOfBirth);
  }

  lastFourSsn (beneficiary: Beneficiary): string {
    if (!beneficiary || !beneficiary.ssn) {
      return "";
    }

    return Ssn.lastFour(beneficiary.ssn);
  }

  share (beneficiary: Beneficiary): string {
    if (beneficiary.share) {
      return beneficiary.share.toFixed(2);
    }
  }

  relationship (beneficiary: Beneficiary): string {
    return _.startCase(beneficiary.relationshipType);
  }

  isEstateBeneficiary (beneficiary: Beneficiary): boolean {
    return beneficiary.relationshipType === BeneficiaryRelationshipType.Estate;
  }

}
